export default __webpack_public_path__ + "static/media/checkbox-circle-line.13b2dc69.svg";